import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import { Categoria } from 'my-lib-sanfelici';
import { Cataloghi } from 'my-lib-sanfelici';
import { CategorieService } from 'my-lib-sanfelici';
import { CataloghiService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-categorie-edit',
  templateUrl: './categorie-edit.component.html',
  styleUrls: ['./categorie-edit.component.css']
})
export class CategorieEditComponent implements OnInit {
    categorie: Observable<Categoria[]>;
    cataloghi: Observable<Cataloghi[]>;
    categoria: Categoria;
   model: any;
    key: string;


    catalogo: Cataloghi;
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private categorieService: CategorieService,
        private cataloghiservice: CataloghiService
    ) { }
    onsubmit() {
this.categoria.parent = this.categoria.parent ? this.categoria.parent : null;
this.categorieService.update( this.categoria);
this.router.navigate(['categorie']);
    }
  ngOnInit() {
      this.key = this.route.snapshot.params.id;
      this.categorieService.get(this.key)
      .subscribe(c => this.categoria = c);
      this.categorie = this.categorieService.list();
      this.cataloghi = this.cataloghiservice.list();
  }

}
